import React from 'react'
import Route from 'route-parser'
import IconButton from '@mui/material/IconButton'
import PrintIcon from '@mui/icons-material/Print'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { getBaseURI } from 'libraries/front-end-core/helpers/document'
import { SEARCH_TYPE_NAMES } from 'constants/search-icons'
import { dismissPopover } from 'services/OverlayService'
import Breadcrumbs from 'components/Breadcrumbs'

const ReviewHeader = ({
  short,
  pdfUrl: url,
  returnUrl,
  returnText,
  isLogged,
  setSignUpModalIsOpen,
  aol,
  type
}) => {
  const pdfUrl = getBaseURI() + new Route(url).reverse({ aol, short })

  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (!isLogged) {
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    }
  }

  return (
    <div className='w-100 bg-page-background'>
      <div className='bg-precedents-blue-20'>
        <div className='layout-width-constraint flex justify-end pr6'>
          <div className='ph2 f5'>
            <IconButton size='small' onClick={handleOnClick}>
              <a
                data-event-category={SEARCH_TYPE_NAMES[type]}
                data-event-action='print'
                href={pdfUrl}
                target='_blank'
                rel='noopener noreferrer'
              >
                <PrintIcon classes={{ root: 'black vm' }} />
              </a>
            </IconButton>
          </div>
          <div className='ph2 f5'>
            <IconButton size='small' onClick={handleOnClick}>
              <a
                href={pdfUrl}
                download='FromCounsel - Selected content.pdf'
                target='_blank'
                rel='noopener noreferrer'
              >
                <PictureAsPdfIcon classes={{ root: 'black vm' }} />
              </a>
            </IconButton>
          </div>
        </div>
      </div>
      <div className='pv6 layout-width-constraint flex justify-between items-center'>
        <Breadcrumbs
          crumbs={[{
            label: SEARCH_TYPE_NAMES[type],
            href: returnUrl
          }]}
          current='Review'
          icon={type}
        />
      </div>
    </div>
  )
}

export default ReviewHeader
